/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tier } from '../../models/tier';

export interface UpdateLoyaltyProgramTier$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
  tierId: string;
      body: Tier
}

export function updateLoyaltyProgramTier(http: HttpClient, rootUrl: string, params: UpdateLoyaltyProgramTier$Params, context?: HttpContext): Observable<StrictHttpResponse<Tier>> {
  const rb = new RequestBuilder(rootUrl, updateLoyaltyProgramTier.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.path('tierId', params.tierId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tier>;
    })
  );
}

updateLoyaltyProgramTier.PATH = '/loyalty/programs/{programId}/tiers/{tierId}';
